import { render, staticRenderFns } from "./PorZona.vue?vue&type=template&id=63a4b54c&lang=pug&"
import script from "./PorZona.vue?vue&type=script&lang=js&"
export * from "./PorZona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports